import { TuiErrorModule, TuiRootModule } from "@taiga-ui/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { ChiSiamoComponent } from './pages/chi-siamo/chi-siamo.component';
import { CorsiComponent } from './pages/corsi/corsi.component';
import { ProgettoComponent } from './pages/progetto/progetto.component';
import { PiattaformaComponent } from './pages/piattaforma/piattaforma.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { HeroComponent } from './shared/hero/hero.component';
import { BannerComponent } from './shared/banner/banner.component';
import { IscrivitiComponent } from './shared/iscriviti/iscriviti.component';
import { ContattiComponent } from './pages/contatti/contatti.component';
import { FormEducatoreComponent } from './shared/form-educatore/form-educatore.component';
import { FormScuolaComponent } from './shared/form-scuola/form-scuola.component';
import { GenericFormComponent } from './shared/generic-form/generic-form.component';
import { TuiCheckboxModule, TuiFieldErrorPipeModule, TuiInputFilesModule } from "@taiga-ui/kit";
import { HttpClientModule } from "@angular/common/http";
import { RECAPTCHA_SETTINGS, RECAPTCHA_V3_SITE_KEY, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings, RecaptchaV3Module } from "ng-recaptcha";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ScratchComponent } from './pages/corsi/scratch/scratch.component';
import { UnpluggedComponent } from './pages/corsi/unplugged/unplugged.component';
import { AppInventorComponent } from './pages/corsi/app-inventor/app-inventor.component';
import { RoboticaEducativaComponent } from './pages/corsi/robotica-educativa/robotica-educativa.component';
import { DigitalStorytellingComponent } from './pages/corsi/digital-storytelling/digital-storytelling.component';
import { EdSocialMediaComponent } from './pages/corsi/ed-social-media/ed-social-media.component';
import { HtmlCssComponent } from './pages/corsi/html-css/html-css.component';
import { MinecraftComponent } from './pages/corsi/minecraft/minecraft.component';
import { UxUiComponent } from './pages/corsi/ux-ui/ux-ui.component';
import { ArduinoComponent } from './pages/corsi/arduino/arduino.component';
import { Stampa3dComponent } from './pages/corsi/stampa3d/stampa3d.component';
import { ProgrammazioneDroniComponent } from './pages/corsi/programmazione-droni/programmazione-droni.component';
import { HeroCoursesComponent } from './shared/hero-courses/hero-courses.component';
import { ErroreComponent } from './pages/errore/errore.component';
import { ModulesComponent } from './shared/modules/modules.component';
import { SuccessConfirmComponent } from './shared/success-confirm/success-confirm.component';
import { ErrorConfirmComponent } from './shared/error-confirm/error-confirm.component';
import { HammerModule } from "../../node_modules/@angular/platform-browser";
import { MatMenuModule } from '@angular/material/menu';
import { LezioniComponent } from './pages/lezioni/lezioni.component';
import { AccessibilityWidgetComponent } from './shared/accessibility-widget/accessibility-widget.component';

const RECAPTCHA_V3_STACKBLITZ_KEY = "6LcvNnonAAAAANh66C_QUSPkXFGdcM8x59YJoxAG"

const globalSettings: RecaptchaSettings = { siteKey: '6LcvNnonAAAAANh66C_QUSPkXFGdcM8x59YJoxAG', badge: "bottomleft" };

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ChiSiamoComponent,
    CorsiComponent,
    ProgettoComponent,
    PiattaformaComponent,
    HeaderComponent,
    FooterComponent,
    HeroComponent,
    BannerComponent,
    IscrivitiComponent,
    ContattiComponent,
    FormEducatoreComponent,
    FormScuolaComponent,
    GenericFormComponent,
    ScratchComponent,
    UnpluggedComponent,
    AppInventorComponent,
    RoboticaEducativaComponent,
    DigitalStorytellingComponent,
    EdSocialMediaComponent,
    HtmlCssComponent,
    MinecraftComponent,
    UxUiComponent,
    ArduinoComponent,
    Stampa3dComponent,
    ProgrammazioneDroniComponent,
    HeroCoursesComponent,
    ErroreComponent,
    ModulesComponent,
    SuccessConfirmComponent,
    ErrorConfirmComponent,
    LezioniComponent,
    AccessibilityWidgetComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HammerModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
      BrowserAnimationsModule,
      TuiRootModule,
      TuiInputFilesModule ,
      HttpClientModule,
      RecaptchaModule,
      RecaptchaFormsModule,
      RecaptchaV3Module,
      TuiFieldErrorPipeModule,
      TuiErrorModule,
      MatMenuModule,
      TuiCheckboxModule
      
],
providers: [ 
  { provide: RECAPTCHA_SETTINGS, useValue: globalSettings },
  { provide: RECAPTCHA_V3_SITE_KEY, useValue: RECAPTCHA_V3_STACKBLITZ_KEY },],
  bootstrap: [AppComponent]
})
export class AppModule { }
